<div class="container-fluid mt-header">
    <div class="row">
        <div class="div-inner">
            <div class="div-carousel">
                <img src="assets/img/contacto/BannerFoto_Contacto.png" class="d-block " alt="contscto">
                <mat-card class="example-card">
                    <mat-card-header>
                        <mat-card-title>¡Contáctanos!</mat-card-title>
                    </mat-card-header>
                </mat-card>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid d-lg-block d-none container-contacto">
    <div class="row">
        <div class="col-12">
            <h3 class="title">Contacto</h3>
        </div>
    </div>
    <div class="row">
      <div class="contacto col-12 mb-5">
          <div class="row">
              <div class="col-3 text-center" *ngFor="let c of contacto">
                  <div class="card">
                      <img [src]="c.img"  [alt]="c.nombreOficina">
                      <div class="card-body">
                        <h5 class="card-title">{{c.nombreOficina}}</h5>
                        <p class="tel">Teléfono</p>
                        <p class="num-tel">{{c.telefono}}</p>
                        <p class="tel">Correo</p>
                        <p class="num-tel margin-correo" *ngFor="let co of c.correo">{{co}}</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="container mt-tablet d-block d-lg-none">
    <div class="row">
        <div class="col-12">
            <h3 class="title">Contacto</h3>
        </div>
    </div>
    <div class="row">
        <div class="contacto col-12 mb-5">
            <div class="row">
                <!--
                    responsivo
                -->
                <div id="carouselContactoMobile" class="carousel slide  slide col-12" data-bs-ride="carousel">
                    <div class="carousel-indicators">
                      <button type="button" data-bs-target="#carouselContactoMobile" [attr.data-bs-slide-to]="j" [ngClass]="{'active': j == 0}" *ngFor="let c of contacto;let j = index" aria-current="true" aria-label="Slide {{j+1}}"></button>
                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item col-12 text-center"
                         [ngClass]="{'active':i==0}" 
                         data-bs-interval="20000" *ngFor="let c of contacto;let i = index"
                         (swipeleft)="sliderCarusel('left','carouselContactoMobile')" 
                         (swiperight)="sliderCarusel('right','carouselContactoMobile')">
                            <div class="card">
                                <img [src]="c.img"  [alt]="c.nombreOficina">
                                <div class="card-body">
                                  <h5 class="card-title">{{c.nombreOficina}}</h5>
                                  <p class="tel">Teléfono</p>
                                  <p class="num-tel">{{c.telefono}}</p>
                                  <p class="tel">Correo</p>
                                  <p class="num-tel margin-correo" *ngFor="let co of c.correo">{{co}}</p>
                                </div>
                            </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>